import React, { Component } from "react";
import { Checkbox, PageHeader, Button, Slider, Icon } from 'antd';

class FlyFacetBar extends Component{

    flyAndImagesSVUsingQuery(filter, myflyloc_got){
        console.log('svoct17********myloc_got',myflyloc_got)
        if(!myflyloc_got){
            console.log('svoct17********nod 0myflyloc_got start')
            console.log(this.props)
            console.log(this.props.svflyfacet_myloc)
           if(this.props.svflyfacet_myloc && this.props.svflyfacet_myloc.my_orgqueryText !='xx'){
            myflyloc_got =this.props.svflyfacet_myloc
            console.log('svoct17********nod 1myflyloc_got',myflyloc_got)
           }
           console.log('svoct17********nod 0myflyloc_got end ')
        }
        console.log('svoct17********nod 2myflyloc_got',myflyloc_got)

        //if you do net selec anyhting  the query puts this as null . we should fix this
        const {
            valueSlider,
            checkedSeat0, checkedSeat1,
            checkedTake0,checkedTake1,checkedTake2,checkedTake3,
            checkedLand0,checkedLand1,checkedLand2,checkedLand3,
            checkedStop0,checkedStop1,
            checkedAirline2, checkedAirline3, 
            checkedAirline4,checkedAirline5,checkedAirline6,
            checkedAirline7,checkedAirline8,

            disabledAirline2, disabledAirline3, 
            checkedAirline2Label, checkedAirline3Label, 
            checkedAirline1,checkedAirline1Label,disabledAirline1
    
    
            }  = filter
        let qarHW = [{"AIRLINES_CODE_IATA": "DL, UA"}]
        const {timesDay} = this.state
        let qar = new Array()   
        let qarStops  = new Array()
        let qarLand = new Array()
        let qarTake = new Array()
        let qarCarry = new Array()
        let qarMaxPrice = new Array()

        let qarSeatSel = new Array()

        //slider
        if(valueSlider > 2){
            qarMaxPrice.push(valueSlider)
        }
        //checkedSeat0
        if(checkedSeat0 && checkedSeat0 == true){
            qarCarry.push("Y")
        }
        if(checkedSeat1 && checkedSeat1 == true){
            qarSeatSel.push("Y")
        }
        if(checkedTake0 && checkedTake0 == true){
            qarTake.push(timesDay.EM)
        }
        if(checkedTake1 && checkedTake1 == true){
            qarTake.push(timesDay.M)
        }
        if(checkedTake2 && checkedTake2 == true){
            qarLand.push(timesDay.A)
        }
        if(checkedTake3 && checkedTake3 == true){
            qarLand.push(timesDay.E)
        }
        //checkedTake0
        if( checkedLand0 && (checkedLand0 == true) ){
            qarLand.push(timesDay.EM)
        }
        if( checkedLand1 && (checkedLand1 == true) ){
            qarLand.push(timesDay.M)
        }
        if( checkedLand2 && (checkedLand2 == true) ){
            qarLand.push(timesDay.A)
        }
        if( checkedLand3 && (checkedLand3 == true) ){
            qarLand.push(timesDay.E)
        }

        //checkedLand0
        if( checkedStop0 && (checkedStop0 == true) ){
            qarStops.push(1)
        }

        if( checkedStop1 && (checkedStop1 == true) ){
            qarStops.push(2)
        }
        if( checkedAirline1 && (checkedAirline1 == true) ){
            qar.push('DL')
        }

        if( checkedAirline2 && (checkedAirline2 == true) ){
            qar.push('KS')
        }

        if( checkedAirline3 && (checkedAirline3 == true) ){
            qar.push('AA')
        }
       
        if( checkedAirline4 && (checkedAirline4 == true) ){
            qar.push("2O")
        }
        /* "2O"
        if( checkedAirline4 && (checkedAirline4 == true) ){
            qar.push('FX')
        }
        */
        if( checkedAirline5 && (checkedAirline5 == true) ){
            qar.push('YR')
        }

        if( checkedAirline6 && (checkedAirline6 == true) ){
            qar.push('UA')
        }
       
        if( checkedAirline7 && (checkedAirline7 == true) ){
            qar.push('AS')
        }

        if( checkedAirline8 && (checkedAirline8 == true) ){
            qar.push('SY')
        }
        /*
        const { startDate, endDate, hotels} = this.props.locationDataView.locationData
        let startDateRq = "", endDateRq = ""
        if(startDate){
            startDateRq = startDate
        }
        if(endDate){
            endDateRq = endDate
        }
        let sojourn_location_s = 'kenServer'
        if(hotels && hotels.values && hotels.values.value){
            sojourn_location_s = hotels.values.value
        }else{

            sojourn_location_s = 'kenServer'
        }

        
        const {values} = hotels
        //call action
        let start_date_s   = moment(startDate).toISOString() 
        console.log("**formatISO***", start_date_s)

        let end_date_s   = moment(endDate).toISOString() 
        console.log("**formatISO***", end_date_s)
        let sojourn_location_s = ''
        if(values && values.value){
            sojourn_location_s = values.value
        }
    
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                    "query": sojourn_location_s,
                    "operator": "and"
                  },
                "startDate": {
                    "query": startDateRq,
                    "operator": "and"
                  },
                  "endDate": {
                    "query": endDateRq,
                    "operator": "and"
                  },
                "checkedAirline2": {
                  "query": checkedAirline2,
                  "operator": "and"
                },
                "checkedAirline3": {
                    "query": checkedAirline3,
                    "operator": "and"
                  }
              }
            }
          }
          console.log('sv*** calling action with postDatae')
          console.log(sojPostRq)
          console.log('sv*** calling action with postDatae done' )
          
          let esRealFacetSearch = {
 
            "query": {
              "bool": {
                "should": [
                  {
                    "match": {
                      "STATE": "WA"
                    }
                  },
                  {
                    "match": {
                      "ADDRESS_LINE1": "Terrace"
                    }
                  },
                  {
                    "match": {
                      "COUNTRY_NAME": "USA"
                    }
                  
                  }
                ]
              }
            },
            "post_filter": {
              "range" : {
                  "STARTDATE": {
                      "gte" : "2023-10-24",
                      "lt" :  "2023-11-27",
                      "time_zone": "+01:00"
                  }
              }
            }
          }
          this.props.sojAndImagesSV(sojPostRq)
          
         let amen_s = qar.join(', ')
          let esRealPostFIlterSearchCanQuery = {
            "post_filter": {
              "range": {
                "STARTDATE": {
                  "gte": "2023-10-24",
                  "lt": "2023-11-27",
                  "time_zone": "+01:00"
                }
              }
            },
            "query": {
              "bool": {
                "must": {
                  "match": {
                      
                    "AIRLINES_NAME_IATA.keyword":amen_s
                  }
                }
              }
            }
          }

        this.props.flyAndImagesSVFacet(esRealPostFIlterSearchCanQuery)
        */
        let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "AIRLINES_NAME_IATA.keyword": ["2O","YR"]
                
            },
            "org":  myflyloc_got.my_orgqueryText || "09A",
            "dst":  myflyloc_got.my_dstqueryText || "ADQ"
        }
        if(qar.length > 0){
            sojPostRq[ "facets"]["AIRLINES_NAME_IATA.keyword"] =qar
        }
       
        if(qarStops.length > 0){
            sojPostRq[ "facets"]["FLIGHT_AIRLINE_NUM_STOPS"] =qarStops
        }
        if(qarMaxPrice.length > 0){
            sojPostRq[ "facets"]["SVMAXIMUXPRICE"] =qarMaxPrice[0]
        }
        

        if(myflyloc_got.my_orgqueryText){
           
            sojPostRq[ "org"] =myflyloc_got.my_orgqueryText
        }
        if(myflyloc_got.my_dstqueryText){
           
            sojPostRq[ "dst"] =myflyloc_got.my_dstqueryText
        }
        if(myflyloc_got.STARTDATE){
           
            sojPostRq[ "dates"][ "STARTDATE_ITN_TZAWARE_EST"] =myflyloc_got.STARTDATE
        }
        if(myflyloc_got.ENDDATE){
           
            sojPostRq[ "dates"][ "ENDDATE_ITN_TZAWARE_EST"] =myflyloc_got.ENDDATE
        }
        const {esqueryChilds,esqueryInfants,esqueryAdults,esqueryCabin,esqueryTripType,svpageSize}  = myflyloc_got
        sojPostRq['esqueryChilds'] = (esqueryChilds ? esqueryChilds : "m0")
        sojPostRq['esqueryInfants'] = (esqueryInfants ? esqueryInfants : "i0")
        sojPostRq['esqueryAdults'] = (esqueryAdults ? esqueryAdults : "t1")
        sojPostRq['esqueryCabin'] = (esqueryCabin ? esqueryCabin : "ECONOMY")
        sojPostRq['esqueryTripType'] = (esqueryTripType ? esqueryTripType : "roundtrip")
        sojPostRq['svpageSize'] = 5
        

        let svfly_esquery_data = myflyloc_got
        console.log("svoct17 faetbar calls action ******sv_esquery_data", svfly_esquery_data)
        this.props.flyAndImagesSVFacet(sojPostRq, svfly_esquery_data)
       
    }

    constructor(props) {
        super(props)
        let me = this
        this.state = {  
           
            timesDay:{
                "EM": {
                    "START":"2:00",
                    "END":"5:59",
                    "DTYPE":"AM"
                },
                "M": {
                    "START":"6:00",
                    "END":"8:59",
                    "DTYPE":"AM"
                },
                "LM": {
                    "START":"9:00",
                    "END":"11:59",
                    "DTYPE":"AM"
                },
                "MD": {
                    "START":"12:00",
                    "END":"12:00",
                    "DTYPE":"PM"
                },
                
                "A": {
                    "START":"12:01",
                    "END":"5:00",
                    "DTYPE":"PM"
                },
                "LA": {
                    "START":"4:00",
                    "END":"5:00",
                    "DTYPE":"PM"
                },
                "EE": {
                    "START":"5:01",
                    "END":"7:00",
                    "DTYPE":"PM"
                },
                "E": {
                    "START":"5:01",
                    "END":"9:00",
                    "DTYPE":"PM"
                },
                "LE": {
                    "START":"9:01",
                    "END":"10:59",
                    "DTYPE":"PM"
                },
                "N": {
                    "START":"23:00",
                    "END":"06:00",
                    "DTYPE":"24HFORMAT"
                },
                "MN": {
                    "START":"12:00",
                    "END":"12:00",
                    "DTYPE":"AM"
                }
            },

            filters: {
                 //svst start
         checkedStFiveLabel:'5 Stars',
         checkedStFive:true,
         disabledStFive:false,

         checkedStFourLabel:'4 Stars',
         checkedStFour:true,
         disabledStFour:false,

         checkedStThreeLabel:'3 Stars',
         checkedStThree:true,
         disabledStThree:false,

         checkedStTwoLabel:'2 Stars',
         checkedStTwo:true,
         disabledStTwo:false,
 

         //svst end
//svlm start
        checkedLmDisneyLabel:'Disaney Springs',
        checkedLmDisney:true,
        disabledLmDisney:false,


//svlm end
        checkedFbCancellationLabel:'Free Cancellation',
        checkedFbCancellation:true,
        disabledFbCancellation:false,

        checkedFbInternetLabel:'Free Internet',
        checkedFbInternet:true,
        disabledFbInternet:false,


        checkedFbParkingLabel:'Free Parking',
        checkedFbParking:true,
        disabledFbParking:false,



        checkedFbBreakfastLabel:'Free Nreakfast',
        checkedFbBreakfast:true,
        disabledFbBreakfast:false,

         //svrs start
         checkedRsExcellentLabel:'9+  Excellent',
         checkedRsExcellent:true,
         disabledRsExcellent:false,
 
         checkedRsGreatLabel:'8+ Great',
         checkedRsGreat:true,
         disabledRsGreat:false,
 
         checkedRsGoodLabel:'7+  Good',
         checkedRsGood:true,
         disabledRsGood:false,
 
         checkedRsOkayLabel:'5+ Okay',
         checkedRsOkay:true,
         disabledRsOkay:false,
 
         //svrs end

                minBudgetPrice:20,
                maxBudgetPrice:4800,
                valueSlider:500,

                checkedAirline3Label:'American Airlines',
                checkedAirline3:true,
                disabledAirline3:false,

                checkedAirline2Label:'Alaska Airlines',
                checkedAirline2:true,
                disabledAirline2:false,

                checkedAirline1Label:'Delta Airlines',
                checkedAirline1:true,
                disabledAirline1:false,
                

                checkedAirline4Label:'Frontier Airlines',
                checkedAirline4:true,
                disabledAirline4:false,

                checkedAirline5Label:'Spirit Airlines',
                checkedAirline5:true,
                disabledAirline5:false,

                checkedAirline7Label:'AS Airlines',
                checkedAirline7:true,
                disabledAirline7:false,

                checkedAirline8Label:'SY Airlines',
                checkedAirline8:true,
                disabledAirline8:false,

                checkedSeat0Label:'Carry On Baggage',
                checkedSeat0:true,
                disabledSeat0:false,
        
                checkedSeat1Label:'Seat Selection',
                checkedSeat1:true,
                disabledSeat1:false,

                checkedTake0Label:'Early Morning',
                checkedTake0:true,
                disabledTake0:false,
        
                checkedTake1Label:'Morning',
                checkedTake1:true,
                disabledTake1:false,
        
                checkedTake2Label:'Afternoon',
                checkedTake2:true,
                disabledTake2:false,
        
                checkedTake3Label:'Evening',
                checkedTake3:true,
                disabledTake3:false,


                checkedLand0Label:'Early Morning',
                checkedLand0:true,
                disabledLand0:false,

                checkedLand1Label:'Morning',
                checkedLand1:true,
                disabledLand1:false,

                checkedLand2Label:'Afternoon',
                checkedLand2:true,
                disabledLand2:false,

                checkedLand3Label:'Evening',
                checkedLand3:true,
                disabledLand3:false,
                
                checkedStop0Label:'Non Stop',
                checkedStop0:true,
                disabledStop0:false,
                
                checkedStop1Label:'1 or More Stops',
                checkedStop1:true,
                disabledStop1:false,

                checkedAirline6Label:'United Airlines',
                checkedAirline6:true,
                disabledAirline6:false

                /*
checkedAirline4,checkedAirline5,checkedAirline6,
            disabledAirline4,disabledAirline5,disabledAirline6,
            checkedAirline4Label,checkedAirline5Label,checkedAirline6Label
      
                */
               




            }
        }
        this.loadCBValuesFromServer = this.loadCBValuesFromServer.bind(this)
        this.onChangeAirline1 = this.onChangeAirline1.bind(me)
        this.onChangeSliderBudget = this.onChangeSliderBudget.bind(me)
        this.onChangeCbAirline4 = this.onChangeCbAirline4.bind(me)
        this.onChangeCbAirline5 = this.onChangeCbAirline5.bind(me)
        this.onChangeCbAirline6 = this.onChangeCbAirline6.bind(me)
        
        this.onChangeCbSeat0 = this.onChangeCbSeat0.bind(me)
        this.onChangeCbSeat1 = this.onChangeCbSeat1.bind(me)

        this.onChangeCbTake0 = this.onChangeCbTake0.bind(me)
        this.onChangeCbTake1 = this.onChangeCbTake1.bind(me)
        this.onChangeCbTake2 = this.onChangeCbTake2.bind(me)
        this.onChangeCbTake3 = this.onChangeCbTake3.bind(me)

        this.onChangeCbLand0 = this.onChangeCbLand0.bind(me)
        this.onChangeCbLand1 = this.onChangeCbLand1.bind(me)
        this.onChangeCbLand2 = this.onChangeCbLand2.bind(me)
        this.onChangeCbLand3 = this.onChangeCbLand3.bind(me)

    }
    loadCBValuesFromServer(){
        console.log('sv--calling acction getFacetDataDefaultFromServer')
        let rqOb = {"notnedded":1}
        //this.props.getFacetDataDefaultFromServer(rqOb)
    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        this.loadCBValuesFromServer()
        //console.log(this.props.params)
    }

    onChangeAirline1=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedAirline1'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
        this.props.saveFlyFacetFilterCheckSuccess(newfacetData)
        

    }

    onChangeSliderBudget(eVal){
        console.log('val = ', eVal);
        let f = this.state.filters
        f['valueSlider'] =eVal

        const comData = f
        let newfacetData = { facetData : comData}
        this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeAirline2=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedAirline2'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeAirline3=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline3 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline1Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline1 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline2Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline2 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline3Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline3 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline4Curry= (param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('onChangeCbAirline4Curry = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline4 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline5Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline5 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline6Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline6 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline7Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline7 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline8Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAirline4Curry for myflyloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline8 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData, svflyfacet_myloc:param1}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline4=(e)=>{
        console.log('onChangeCbAirline4 = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline4 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline5=(e)=>{
        console.log('onChangeCbAirline5 = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline5 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline6=(e)=>{
        console.log('onChangeCbAirline6 = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline6 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }

    onChangeCbAirline7=(e)=>{
        console.log('onChangeCbAirline7 = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline7 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAirline8=(e)=>{
        console.log('onChangeCbAirline8 = ', e.target.checked);
         let f = this.state.filters
         f.checkedAirline8 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbStop0=(e)=>{
        console.log('onChangeCbStop0 = ', e.target.checked);
         let f = this.state.filters
         f.checkedStop0 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }

    onChangeCbStop1=(e)=>{
        console.log('onChangeCbStop1 = ', e.target.checked);
         let f = this.state.filters
         f.checkedStop1 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbTake0=(e)=>{
        console.log('onChangeCbTake0 = ', e.target.checked);
         let f = this.state.filters
         f.checkedTake0 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbTake1=(e)=>{
        console.log('onChangeCbTake1 = ', e.target.checked);
         let f = this.state.filters
         f.checkedTake1 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbTake2=(e)=>{
        console.log('onChangeCbTake2 = ', e.target.checked);
         let f = this.state.filters
         f.checkedTake2 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbTake3=(e)=>{
        console.log('onChangeCbTake3 = ', e.target.checked);
         let f = this.state.filters
         f.checkedTake3 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }

    onChangeCbLand0=(e)=>{
        console.log('onChangeCbLand0 = ', e.target.checked);
         let f = this.state.filters
         f.checkedLand0 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbLand1=(e)=>{
        console.log('onChangeCbLand1 = ', e.target.checked);
         let f = this.state.filters
         f.checkedLand1 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbLand2=(e)=>{
        console.log('onChangeCbLand2 = ', e.target.checked);
         let f = this.state.filters
         f.checkedLand2 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbLand3=(e)=>{
        console.log('onChangeCbLand3 = ', e.target.checked);
         let f = this.state.filters
         f.checkedLand3 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }

    onChangeCbSeat0=(e)=>{
        console.log('onChangeCbSeat0 = ', e.target.checked);
         let f = this.state.filters
         f.checkedSeat0 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbSeat1=(e)=>{
        console.log('onChangeCbSeat1 = ', e.target.checked);
         let f = this.state.filters
         f.checkedSeat1 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFlyFacetFilterCheckSuccess(newfacetData)

    }

    //onChangeCbAirline5
    render(){
        const me = this
        console.log('sv*** this.props')
        const {flyfacetDataView, my_esqueryText} = this.props
        const {facetData} = flyfacetDataView

      //  const {facetData} = this.props
        console.log(this.props)
        const {myflyloc} = this.props
        console.log(myflyloc)
        let facetDataGot 
        if(facetData['facetData']){
            facetDataGot = facetData['facetData']
        }else{
            facetDataGot = facetData
        }
        const {
            checkedAirline2, checkedAirline3, 
            disabledAirline2, disabledAirline3, 
            checkedAirline2Label, checkedAirline3Label, 
            checkedAirline1,checkedAirline1Label,disabledAirline1,


            checkedAirline4,checkedAirline5,checkedAirline6,
            disabledAirline4,disabledAirline5,disabledAirline6,
           
            checkedAirline4Label,checkedAirline5Label,checkedAirline6Label,

            checkedAirline7,checkedAirline8,
            disabledAirline7,disabledAirline8,
            checkedAirline7Label,checkedAirline8Label,

            checkedSeat0,checkedSeat1,
            disabledSeat0,disabledSeat1,
            checkedSeat0Label, checkedSeat1Label,


            checkedTake0,checkedTake1,checkedTake2,checkedTake3,
            disabledTake0,disabledTake1,disabledTake2,disabledTake3,
            checkedTake0Label, checkedTake1Label,checkedTake2Label,checkedTake3Label,

            checkedLand0,checkedLand1,checkedLand2,checkedLand3,
            disabledLand0,disabledLand1,disabledLand2,disabledLand3,
            checkedLand0Label, checkedLand1Label,checkedLand2Label,checkedLand3Label,



            checkedStop0,checkedStop1,
            disabledStop0, disabledStop1,
            checkedStop0Label, checkedStop1Label

    
    
            } = facetDataGot
        //const {minBudgetPrice, maxBudgetPrice} =  facetDataGot
        const {valueSlider} =  facetDataGot
       // let valueSlider = 100, 
        let minBudgetPrice = 20, maxBudgetPrice = 800
        const mid = ((maxBudgetPrice - minBudgetPrice) / 2).toFixed(5);
    const preColor = valueSlider >= mid ? '' : 'rgba(0, 0, 0, .45)';
    const nextColor = valueSlider >= mid ? 'rgba(0, 0, 0, .45)' : '';
  

        console.log('sv*** this.props*****facebar')
        const {locationDataView} = this.props
        const {locationData} = locationDataView
        console.log(this.props)
        
        const bdisableDaysBeforeToday = true
        return (
            <div> Advanced Search 
                <Button onClick={()=>this.flyAndImagesSVUsingQuery(this.state.filters, myflyloc)} type="dashed" shape="circle" icon="filter" />
                    <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                        
                            padding: '5px 0 5px 0'
                                /* border-color: #4e5555; */
                        
                            }}
                            title="Budget"
                        
                            subTitle=""
                            >

                        </PageHeader>
                        <div className="icon-wrapper">
                                <Icon style={{ color: preColor }} type="frown-o" />
                                <Slider min={minBudgetPrice} max={maxBudgetPrice} onChange={this.onChangeSliderBudget} value={valueSlider} />
                                <Icon style={{ color: nextColor }} type="smile-o" />
                        </div>

                        <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Takeoff"
                            subTitle=""
                        >

                        </PageHeader>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedTake0}
                                    disabled={disabledTake0}
                                    onChange={this.onChangeCbTake0}
                                >
                                    {checkedTake0Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedTake1}
                                    disabled={disabledTake1}
                                    onChange={this.onChangeCbTake1}
                                >
                                    {checkedTake1Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedTake2}
                                    disabled={disabledTake2}
                                    onChange={this.onChangeCbTake2}
                                >
                                    {checkedTake2Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedTake3}
                                    disabled={disabledTake3}
                                    onChange={this.onChangeCbTake3}
                                >
                                    {checkedTake3Label}
                                </Checkbox>
                            </p>
                         </div>
                         <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Landing"
                            subTitle=""
                        >

                        </PageHeader>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLand0}
                                    disabled={disabledLand0}
                                    onChange={this.onChangeCbLand0}
                                >
                                    {checkedLand0Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLand1}
                                    disabled={disabledLand1}
                                    onChange={this.onChangeCbLand1}
                                >
                                    {checkedLand1Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLand2}
                                    disabled={disabledLand2}
                                    onChange={this.onChangeCbLand2}
                                >
                                    {checkedLand2Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLand3}
                                    disabled={disabledLand3}
                                    onChange={this.onChangeCbLand3}
                                >
                                    {checkedLand3Label}
                                </Checkbox>
                            </p>
                         </div>
                        <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Stops"
                            subTitle=""
                        >

                        </PageHeader>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStop0}
                                    disabled={disabledStop0}
                                    onChange={this.onChangeCbStop0}
                                >
                                    {checkedStop0Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStop1}
                                    disabled={disabledStop1}
                                    onChange={this.onChangeCbStop1}
                                >
                                    {checkedStop1Label}
                                </Checkbox>
                            </p>
                         </div>
                        
                        <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Airlines"
                            subTitle=""
                        >

                        </PageHeader>
                        <div>


                            <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline1}
                                    disabled={disabledAirline1}
                                    onChange={this.onChangeCbAirline1Curry(myflyloc, this)}
                                >
                                    {checkedAirline1Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline2}
                                    disabled={disabledAirline2}
                                   
                                    onChange={this.onChangeCbAirline2Curry(myflyloc, this)}
                                >
                                    {checkedAirline2Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline3}
                                    disabled={disabledAirline3}
                                    onChange={this.onChangeCbAirline3Curry(myflyloc, this)}
                                >
                                    {checkedAirline3Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline4}
                                    disabled={disabledAirline4}
                                    onChange={this.onChangeCbAirline4Curry(myflyloc, this)}
                                >
                                    {checkedAirline4Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline5}
                                    disabled={disabledAirline5}
                                    onChange={this.onChangeCbAirline5Curry(myflyloc, this)}
                                >
                                    {checkedAirline5Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline6}
                                    disabled={disabledAirline6}
                                    onChange={this.onChangeCbAirline6Curry(myflyloc, this)}
                                >
                                    {checkedAirline6Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline7}
                                    disabled={disabledAirline7}
                                    onChange={this.onChangeCbAirline7Curry(myflyloc, this)}
                                >
                                    {checkedAirline7Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAirline8}
                                    disabled={disabledAirline8}
                                    onChange={this.onChangeCbAirline8Curry(myflyloc, this)}
                                >
                                    {checkedAirline8Label}
                                </Checkbox>
                            </p>
                         </div>
                         <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Seat Selections"
                            subTitle=""
                        >

                        </PageHeader>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedSeat0}
                                    disabled={disabledSeat0}
                                    onChange={this.onChangeCbSeat0}
                                >
                                    {checkedSeat0Label}
                                </Checkbox>
                            </p>
                         </div>

                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedSeat1}
                                    disabled={disabledSeat1}
                                    onChange={this.onChangeCbSeat1}
                                >
                                    {checkedSeat1Label}
                                </Checkbox>
                            </p>
                         </div>
                        
            </div>
        )
    }
}

export default FlyFacetBar